var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BContainer',{staticClass:"py-5"},[_c('BCard',{attrs:{"no-body":""}},[_c('BCardHeader',{staticClass:"bg-primary"},[_c('h3',{staticClass:"m-0 text-light"},[_vm._v("Products")])]),_c('BCardBody')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }